/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterM = createReactComponent("circle-letter-m", "IconCircleLetterM", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 16v-8l3 5l3 -5v8", key: "svg-1" }]
]);

export { IconCircleLetterM as default };
//# sourceMappingURL=IconCircleLetterM.js.map
